import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M6.497 1.332a12 12 0 0 0-2.983 2.182c-.9.9-1.628 1.909-2.182 2.983l7.716 8.454 8.454 7.716a12 12 0 0 0 2.983-2.182c.9-.9 1.628-1.909 2.182-2.983l-7.716-8.454z\"></path><path fill=\"#000\" d=\"M20.487 20.486q.755-.756 1.347-1.604L5.12 2.167a12.1 12.1 0 0 0-2.952 2.952l16.715 16.714q.846-.593 1.604-1.347\"></path><path fill=\"#D80027\" d=\"M3.514 20.487c3.786 3.786 9.472 4.512 13.988 2.181L1.332 6.498C-.997 11.016-.27 16.702 3.515 20.487M20.484 3.515C16.698-.271 11.012-.998 6.496 1.333l16.17 16.17c2.33-4.517 1.604-10.202-2.182-13.988\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }